import { Icon } from '@easy-expense/ui-shared-components';
import { theme } from '@easy-expense/ui-theme';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';

type RowCardProps = {
  iconName: React.ComponentProps<typeof Icon>['name'];
  title: string;
  description: string;
  action: React.ReactNode;
  variant?: 'default' | 'danger';
};

export const RowCard: React.FC<RowCardProps> = ({
  iconName,
  title,
  description,
  action,
  variant = 'default',
}) => {
  const isDanger = variant === 'danger';
  return (
    <Layout.Row
      align
      bg="white"
      border={[1, 'solid', 'inputBorder']}
      radius={16}
      py={16}
      px={20}
      style={{ gap: 16 }}
    >
      <Layout.Column
        center
        radius={10}
        style={{
          width: 40,
          height: 40,
          backgroundColor: isDanger
            ? theme.colors.destructiveXLight
            : theme.colors.brandPrimaryXLight,
          flexShrink: 0,
        }}
      >
        <Icon
          name={iconName}
          size={20}
          color={isDanger ? theme.colors.destructive : theme.colors.brandPrimary}
        />
      </Layout.Column>
      <Layout.Column grow>
        <OpenSans.Primary weight="bold-700" size="s-16" color="primary">
          {title}
        </OpenSans.Primary>
        <Spacer.Vertical size={2} />
        <OpenSans.Primary size="xs-12" color="secondary">
          {description}
        </OpenSans.Primary>
      </Layout.Column>
      {action}
    </Layout.Row>
  );
};
